import { render, staticRenderFns } from "./CasePersonalJewellery.vue?vue&type=template&id=0e877c02"
import script from "./CasePersonalJewellery.vue?vue&type=script&lang=js"
export * from "./CasePersonalJewellery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports